import { PageHeader } from "@/components/ui";
import { GanttView } from "@/domains/planning/components/ganttView";
import { AvailabilityCheck } from "@/domains/planning/components/availabilityCheck";

export function PlanningPage(): React.JSX.Element {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Planning"
        subtitle="Tijdslijn-view van alle asset-bezetting en een interactieve beschikbaarheidschecker."
      />
      <GanttView rangeStart="2026-05-04" rangeDays={21} />
      <AvailabilityCheck />
    </div>
  );
}
